import type { ReactElement } from 'react';

import { Box, Tooltip } from '@mui/material';

import { Z_INDEX } from '@/config/z-index';

export const PreviewImageTooltip = ({
  children,
  previewImage,
  height = 150
}: {
  children: ReactElement;
  previewImage?: string;
  height?: number;
}) => {
  if (!previewImage) {
    return children;
  }

  return (
    <Tooltip
      enterDelay={150}
      leaveDelay={50}
      placement='left'
      slotProps={{
        popper: {
          sx: {
            zIndex: Z_INDEX.loadingBackdrop
          }
        },
        tooltip: {
          sx: {
            backgroundColor: 'gx.tileDark',
            p: 0,
            m: 0
          }
        }
      }}
      title={
        <Box
          sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
            p: 0.5,
            height
          }}
        >
          <Box
            alt='Preview'
            component='img'
            src={previewImage}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              objectPosition: 'center'
            }}
          />
        </Box>
      }
    >
      {children}
    </Tooltip>
  );
};
